// Get all .faq-question
if( document.getElementsByClassName("fmp-faqs-section__question") ) {
  var questions = document.getElementsByClassName("fmp-faqs-section__question");

  // Assign openQuestion on click
  for ( var i = 0; i < questions.length; i++ ) {
    questions[i].onclick = openQuestion;
  }

  // Apply .hidden to sibling .faq-answer
  // Apply .open to .faq-question
  function openQuestion(event) {
    var answer = (event.target).parentNode.getElementsByClassName("fmp-faqs-section__answer")[0];
    if ( -1 !== answer.className.indexOf( "hidden" ) ) {
      answer.className = answer.className.replace( " hidden", "" );
    } else {
      answer.className += " hidden";
    }
    if ( -1 !== event.target.className.indexOf( "open" ) ) {
      event.target.className = event.target.className.replace( " open", "" );
    } else {
      event.target.className += " open";
    }
  }

  if( document.getElementById("fmp-more-faqs") ){
    var moreFAQs = document.getElementById("fmp-more-faqs");
    moreFAQs.addEventListener("click", function (e) {
      this.querySelector("span").classList.toggle('less');
      this.querySelector("span").innerText = ( 'More FAQs' == this.querySelector("span").innerText ) ? 'Less FAQs' : 'More FAQs';

      var faqItem = document.querySelectorAll(".fmp-faqs-section__item");
      for ( var i = 0; i < faqItem.length; i++ ) {
        if( i > 4 ){
          faqItem[i].classList.toggle('fmp-hidden');
        }
      }
    } );
  }

}
